import { extractTileAmtQueryParam } from "../types/plp-filter-functions.types";
import { ICommonParams, IFiltersData, IRequestApi } from "../types/type-plp-filters.types";
import { API_PATHS } from "../constants/api-paths";
import { createCacheAsync } from "@repo/shared-utils/cache";
import { IResponse, request } from "../core/api.client";

export interface IFilterResults {
  count: number;
  results: ISkuCard[];
  icorsResults: ISkuCard[];
}

export interface ISkuCard {
  skuId: string;
  category: string;
  subCategory: string;
  business: string;
  productCode: string;
  productSkuLabel: string;
  amountPrefix: string;
  displayLoanAmount: string;
  loanAmountSuffix: string;
  actualLoanAmount: number;
  emiAmountText: string;
  emiAmount: number;
  tenure: number;
  tenureSuffix: string;
  roi: number;
  uspText: string;
  disbursalTime: number;
  cta: {
    label: string;
    appLink: string;
    webLink: string;
  };
  nudge1: string;
  nudge2: string;
  employmentType: string;
  loanType: string;
  variant: string;
  businessSegment: string;
  documentation: string;
  rating: number;
  relatedSkuIds: string[];
  sequence: number;
  clpSectionName: string;
  plpSectionName: string;
  displayAmountPrefix1?: string;
  displayAmountPrefix2?: string;
  usp1Text?: string;
  usp2Text?: string;
  displayAmount?: string;
  skuImage?: string;
  displayAmountSuffix?: string;
}

export const fetchPlpFilters = async (params: ICommonParams): Promise<IFiltersData> => {
  try {
    const response: IResponse<IFiltersData> = await createCacheAsync(
      `POST-${API_PATHS.filterResults}-${JSON.stringify(params)}`,
      request<IFiltersData>,
      {
        method: "POST",
        url: API_PATHS.filters,
        data: {
          category: params.category,
          subCategory: params.subCategory,
          locale: params.locale,
        },
      }
    );
    return response.data;
  } catch (e) {
    console.error("Filters API failed", e);
    return {} as IFiltersData;
  }
};

const processActualLoanAmount = (params: IRequestApi): IRequestApi => {
  const extractedTileAmount = extractTileAmtQueryParam() as number[] | null;
  if (extractedTileAmount) {
    return {
      actualLoanAmount: [extractedTileAmount, ...(params.actualLoanAmount ?? [])],
    };
  }
  if (!extractedTileAmount && params.actualLoanAmount) {
    return {
      actualLoanAmount: params.actualLoanAmount,
    };
  }
  return {} as IRequestApi;
};

export const fetchPlpFilterResults = async (params: IRequestApi): Promise<IFilterResults> => {
  try {
    const response = await createCacheAsync(
      `POST-${API_PATHS.filterResults}-${JSON.stringify(params)}`,
      request<IFilterResults>,
      {
        method: "POST",
        url: API_PATHS.filterResults,
        data: {
          ...params,
          webFlag: "Yes",
          ...processActualLoanAmount(params),
        },
      }
    );
    // Return data with count - caller can decide if "Show More" should be enabled
    // Logic: !isMobile ? count > 15 : count >= resultsLimit
    return response.data;
  } catch (e) {
    console.error("Results API failed", e);
    return {} as IFilterResults;
  }
};
